import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import { MdsSearch } from "@sinch/icons";
import { useEffect, useRef } from "react";
import { MdsIcon } from "@sinch/components";

export const ListSearchField = ({
  onChange,
  value,
  loading,
}: {
  onChange: (val: string) => void;
  value: string;
  loading?: boolean;
}) => {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, []);
  return (
    <TextField
      fullWidth
      hiddenLabel
      inputRef={ref}
      onChange={(e) => onChange(e.target.value)}
      onMouseDown={(e) => e.stopPropagation()}
      placeholder="Search"
      size="medium"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              {loading && <CircularProgress color="secondary" size={20} />}
              {!loading && <MdsIcon fontSize="small" icon={MdsSearch} />}
            </InputAdornment>
          ),
        },
      }}
      value={value}
      variant="filled"
    />
  );
};
